import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { BigCard, Tabela, Header } from '@equipedigitalfloripa/ed-cms/components'
import * as colaboradorApi from '../api/colaborador'

const Colaborador = () => {

  const columns = [
    {
      title: "Imagem",
      field: '_id',
      filtering: false,
      sorting: false,
      cellStyle: {
        maxWidth: 66,
      },
      render: rowData =>
        <img
          className="noticia-img"
          src={colaboradorApi.getFileColaborador(rowData._id)}
          alt="" />
    },
    {
      title: "Nome",
      field: "name",
      sorting: true
    },
  ];

  // const options = {
  //   filtering: true,
  //   actionsColumnIndex: -1,
  //   paging: false
  // }

  return (
    <React.Fragment>
      <Header title={"Colaborador"} subtitle={"Lista de colaborador"}>
        <i className="fas fa-coins awesome-header"></i>
      </Header>
      <Container className="page-content">
        <BigCard>
          <Tabela
            url={'colaborador'}
            columns={columns}
            fetchFunction={colaboradorApi.fetchItems}
            removeFunction={colaboradorApi.removeItem}
            statusFunction={colaboradorApi.statusItem}
            enableSearch
          />
        </BigCard>
      </Container>
    </React.Fragment>
  )
}

export default Colaborador
